import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 36199A40-CCCB-44B9-A6B0-73F7315E5716
 * name arrow-up-bold
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold.svg
 * tags
 * - Arrow 
 */
export const ArrowUpBoldIcon = createSvgIcon(<><path d="M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z" /></>, 'ArrowUpBoldIcon');
export default ArrowUpBoldIcon